import { GetPoliciesQueryArg } from '../types/query-arg';
import { GetPoliciesQueryParams } from '../types/query-params';

export const getPoliciesQueryParams = (
  queryArg: GetPoliciesQueryArg,
): GetPoliciesQueryParams => ({
  organisationId: queryArg.organisation.id,
});
